import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import Logo from "../components/Logo";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import api, { formatApiErrorDetail } from "../lib/api";
import BackButton from "../components/BackButton";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen paper-grain flex items-center justify-center px-6 py-12 relative">
      <BackButton className="absolute top-4 left-4" />
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8">
          <Logo size={44} />
          <span className="font-serif text-xl font-bold text-[#0B2A45]">Guatemalan Spirits &amp; Fruit Juice</span>
        </Link>
        <div className="bg-white rounded-2xl shadow-xl border border-stone-200 p-8">
          <h1 className="font-serif text-2xl font-semibold text-[#0B2A45] mb-1">Recupera password</h1>
          {sent ? (
            <p className="text-sm text-stone-600 mt-4" data-testid="forgot-confirmation">
              Se l'email è registrata, riceverai a breve un link per reimpostare la password.
            </p>
          ) : (
            <>
              <p className="text-sm text-stone-500 mb-6">Inserisci la tua email: ti invieremo un link di reimpostazione.</p>
              <form onSubmit={submit} className="space-y-4">
                <div>
                  <Label htmlFor="email">Email</Label>
                  <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                         required data-testid="forgot-email-input" className="mt-1.5" />
                </div>
                {error && <p className="text-sm text-red-600">{error}</p>}
                <Button type="submit" disabled={loading} data-testid="forgot-submit-btn"
                        className="w-full bg-[#0F4C81] hover:bg-[#0A365C] text-white h-11 rounded-full">
                  {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Invia link"}
                </Button>
              </form>
            </>
          )}
          <div className="mt-4 text-center">
            <Link to="/accedi" className="text-sm text-[#0F4C81] hover:underline">Torna all'accesso</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
